
import youtube from './images/youtube.svg';

const videos = [{
  icon: youtube,
  text: 'landing.cx.watchNow.youtube.introduction',
  url: '',
}];

export default videos;



// WEBPACK FOOTER //
// ./src/components/CXLanding/videos.js